import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    container: {
      display: "flex",
      flexWrap: "wrap",
      gap: "16px",
      marginTop: "16px",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "center",
      },
    },
    card: {
      width: "450px",
      height: "277px",
      padding: "24px",
      overflow: "visible",
      background: theme.palette.background.primary,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        height: "auto",
        maxWidth: "360px",
        margin: "0 4px",
      },
    },
    header: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      marginBottom: "16px",
    },
    headerLeft: {
      display: "flex",
      flexDirection: "column",
    },
    title: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "28px",
      color: theme.palette.text.primary,
    },
    secondary: {
      fontSize: "16px",
      fontWeight: 600,
      color: theme.palette.text.secondary,
      marginTop: "2px",
    },
    menuIcon: {
      padding: 0,

      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    option: {
      display: "flex",
      padding: "9px 10px",
      gap: "8px",
      margin: "1px 0",
      fontSize: "14px",
      fontWeight: 500,
      color: theme.palette.text.secondary,

      "&:hover": {
        backgroundColor: theme.palette.button.bg_hover,
      },
    },
    content: {
      display: "flex",
      marginTop: "16px",
      alignItems: "flex-start",
      gap: "12px",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    unitTypes: {
      fontSize: "16px",
      fontWeight: 500,
      color: theme.palette.text.tertiary,
    },
    mainHeader: {
      fontSize: "48px",
      fontWeight: 600,
      color: theme.palette.text.brand_tertiary,
    },
    subHeader: {
      fontSize: "18px",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
  };
});
